
export class chats {
  chats: chat[];
  constructor(data: any)
  {
    this.chats = data.chats.map((msg: any) => new chat(msg));
  }
}

export class chat {
  chatId: string;
  chatTitle: string;
  type: string;
  chatSummary: string;
  constructor(data: any) {
    this.chatId = data.chatId;
    this.chatTitle = data.chatTitle;
    this.type = data.type;
    this.chatSummary = data.chatSummary;
  }
}
export class chatSlim {
  chatId: string;
  constructor(data: any) {
    this.chatId = data.chatId;
  }
}
